import { Flex, Button, FormControl } from '@chakra-ui/react';

const ReferenceRating = ({
  rating,
  value,
  setFieldValue,
}: ReferenceRatingProps): JSX.Element => {
  return (
    <Flex direction="row" justifyContent="space-between" mb={4}>
      {Array.from({ length: 7 }, (v, i) => i + 1).map((val) => (
        <FormControl
          id={`${rating}-${val}`}
          key={val}
          display="flex"
          justifyContent="center"
          _first={{
            justifyContent: 'flex-start',
          }}
          _last={{
            justifyContent: 'flex-end',
          }}
          mb={2}
        >
          <Button
            height="32px"
            width="32px"
            minWidth="unset"
            borderRadius="50%"
            border="1px solid #EFEFEF"
            bg={value === val ? 'custom.levoBlue' : 'white'}
            color={value === val ? 'white' : '#999999'}
            fontWeight={700}
            fontSize="16px"
            lineHeight="19.2px"
            letterSpacing="3%"
            onClick={() => setFieldValue(rating, val)}
          >
            {val}
          </Button>
        </FormControl>
      ))}
    </Flex>
  );
};

export default ReferenceRating;
